export class ActivityInfo {
  constructor () {
    this.activityId = ''
    this.activityStatus = 1 // 活动状态 1-进行中 2-已结束
    this.guidePic = '' // 引导图
    this.appkey = ''
    this.bindLimit = 0 // 绑定限制
    this.bindRoleNum = 0 // 绑定角色次数
    this.createRoleTime = '' // 创建角色时间
    this.endDay = '' // 活动结束时间-用户创角X天后结束
    this.gameIcon = '' 
    this.gameName = '' 
    this.gameType = '' 
    this.guidePic = '' // 引导截图
    this.icon = '' // 头图
    this.moduleVoList = [] // 礼包模块
    this.name = '' // 活动名称
    this.planUrl = '' // 计划链接
    this.rewardId = '' // 福利id
    this.roleBind = false // 是否绑定角色
    this.roleId = '' // 角色ID, roleBind = true 返回
    this.roleName = '' // 角色名, roleBind = true 返回
    this.rule = '' // 活动规则
    this.serverId = '' // 区服ID
    this.serverName = '' // 区服名
    this.styleType = 1 // 活动样式主题 1-背景1 2-背景2
    this.uid = '' // 用户id, roleBind = true 返回
    this.username = '' // 用户名, roleBind = true 返回
  }
}

export const FEEDTYPE_MAP = {
  SUCCESS: 'SUCCESS', // 成功
  CONDITION_NOT_SATISFY: 'CONDITION_NOT_SATISFY',
  CONFIRM: 'CONFIRM', // 领取确认
  SHOW_GIFT: 'SHOW_GIFT', // 礼包展示
  MORE_GAME: 'MORE_GAME', // 更多游戏
  REACH_LIMIT: 'REACH_LIMIT', // 已达上限
  RULE: 'RULE', // 规则
}